export default {
    webPushEndpointId: 'Travelata.travelata-whitelabels',
    endpointId: 'Travelata.travelata-whitelabels',
    pointOfContactSystemName: '',
    firebaseMessagingSenderId: '',
};